import { VerificationStep } from '@sheerid/jslib';

const events = {
    EVENT_CATEGORY: 'Verification',
};

export const recordEvent = (step: VerificationStep, label: string = '') => {
    // @ts-expect-error
    window.ga('send', 'event', events.EVENT_CATEGORY, step, label);
};
